module.exports = __webpack_public_path__ + "about-us-b998e096/free-cover-3afb766bab04848423d6efdb4f226321.svg";